// @flow
import * as React from 'react';
import styled from 'styled-components';

import { ButtonSecondaryLink } from '../ButtonSecondary';

import colors from '../../assets/css/colors';

const MessageText = styled.h4`
	font-size: 15px;
	line-height: 1.5;
	font-weight: bold;
	text-align: center;
	color: ${colors.darkGrey};
	margin-bottom: ${({ bottom_space }) => bottom_space ? '20px' : '0'};
`;

const Wrapper = styled.div`
	background: white;
	padding: 30px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

type Props = {
	league_id: number,
	is_league_overview_page: boolean
}

const ByeRoundMessage = ({ league_id, is_league_overview_page }: Props) => (
	<Wrapper>
		<MessageText bottom_space={!is_league_overview_page}>
			Your league has chosen not to play during NRL Bye rounds
		</MessageText>
		{!is_league_overview_page && <ButtonSecondaryLink to={`/league/${league_id}/`}>
			Go to your League Overview
		</ButtonSecondaryLink>}
	</Wrapper>
);

export default ByeRoundMessage;


// WEBPACK FOOTER //
// ./src/components/Fixtures/ByeRoundMessage.js